import { Typography } from '@mui/material';
import { styled } from '@mui/system';
import * as React from 'react';

const SkillHeader = styled(Typography)`
  // color: #07e7f7;
  color: #f70743;
  font-family: Copperplate, Papyrus, fantasy;
  font-size: 40px;
  text-align: center;
  font-weight: bold;
  margin: 10px 0;
  padding: 10px 0;
  &::after{
    border-bottom: 1px dotted black;
  }
`
export default function ContentHeader(props) {
    return (
        <SkillHeader>
            {props.name}
        </SkillHeader>
    )
}
